<template>
  <div class="app flex-row align-items-center" id="forgot-page">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col lg="6" md="8">
          <el-card class="box-card">
            <h3 class="text-center title">Quên mật khẩu</h3>
            <b-alert
              variant="danger"
              dismissible
              :show="mData.dataDefault.showDismissibleAlert"
              @dismissed="mData.dataDefault.showDismissibleAlert = false"
              style="white-space: pre-wrap"
              >{{ mData.dataDefault.error }}</b-alert
            >
            <b-alert
              variant="success"
              dismissible
              :show="mData.dataDefault.showDismissibleAlertSuccess"
              @dismissed="mData.dataDefault.showDismissibleAlertSuccess = false"
              >{{ mData.dataDefault.success }}</b-alert
            >

            <el-form
              class="mt-3"
              :model="mData.dataForm"
              :rules="mData.validForm"
              ref="myForm"
              label-width="100%"
              label-position="top"
              @submit.native.prevent
            >
              <el-form-item label="Nhập Tài khoản để lấy lại mật khẩu" prop="account">
                <el-input
                  prefix-icon="el-icon-user"
                  v-model.trim="mData.dataForm.account"
                  clearable
                  placeholder="Tải khoản"
                ></el-input>
              </el-form-item>

              <el-form-item class="text-center mt-4">
                <el-button
                  v-loading="loading"
                  :disabled="loading"
                  element-loading-spinner="el-icon-loading"
                  class="ladda-button"
                  type="primary"
                  @click="fn_submitForm()"
                  v-ladda
                  native-type="submit"
                >
                  Gửi mã khôi phục
                </el-button>
              </el-form-item>
            </el-form>
            <b-col md="12" class="text-center">
              <b-link class="back-login" to="/auth/login"
                >Quay lại trang đăng nhập</b-link
              >
            </b-col>
          </el-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import AuthService from "../../service/AuthService";
import LanguageService from "../../service/LanguageService";
import ValidService from "../../service/ValidService";
import MethodService from "../../service/MethodService";
import AccountApi from "../../moduleApi/UserApi";
import * as Ladda from "ladda";

export default {
  data() {
    return {
      loading: false,
      aLang: LanguageService.lang,
      haveError: false,
      mData: {
        dataDefault: {
          error: "",
          showDismissibleAlert: false,
          success: "",
          showDismissibleAlertSuccess: false,
        },
        dataForm: {
          account: "",
        },
        validForm: {
          account: [ValidService.required],
        },
        accountChooseFromDialog: "",
        listAccount: [],
      },
    };
  },
  methods: {
    fn_submitForm() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.fn_recoverPassword(this.mData.dataForm.account);
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_recoverPassword(account) {
      this.loading = true;
      AuthService.recoverPassword(account)
        .then((res) => {
          this.loading = false;
          this.$router.push({
            name: "Auth-ResetPassword",
            query: { account: account },
            params: {
              msg: res.result && res.result.msg ? res.result.msg : null,
            },
          });
        })
        .catch((error) => {
          console.log("error",error.code);
          this.mData.dataDefault.showDismissibleAlert = true;
          if (error.code == -1) this.mData.dataDefault.error = `Tài khoản ${account} không tồn tại. Vui lòng thử lại!`;
          if (error.code == 4) this.mData.dataDefault.error = `Có vấn đề về đường tryền mạng. Vui lòng thử lại!`;
          this.loading = false;
        });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
  },
};
</script>

<style scoped>
#forgot-page {
  background-image: url("/img/BG-Login.png");
  background-color: var(--white);
  z-index: 4000;
  display: block;
  font-family: "Montserrat", sans-serif;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: right;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
}
::v-deep .el-card {
  margin-top: 120px;
}
.title {
  text-transform: uppercase;
  margin-bottom: 5px;
  font-family: UTM AvoBold !important;
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 53px;
  color: var(--orange_text);
  text-shadow: 0px 4px 20px rgba(1, 143, 255, 0.1);
}
.back-login {
  font-family: UTM Avo;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  text-decoration-line: underline;
  color: var(--orange_text) !important;
}
::v-deep .list_account .el-dialog {
  margin-top: 20vh !important;
}
::v-deep .list_account .el-dialog .el-dialog__body {
  padding: 15px;
}

::v-deep .list_account .el-radio,
::v-deep .list_account .el-radio__input {
  white-space: normal;
  word-break: initial;
}
::v-deep .el-loading-spinner {
  top: 30%;
  margin-top: 0px;
}
::v-deep .el-button--small {
  padding: 10px 15px;
}
::v-deep .el-button--primary {
  border: transparent;
}
::v-deep .list_account .el-dialog .el-dialog__title {
  padding-right: 20px;
  display: block;
}

@media (min-width: 500px) and (max-width: 768px) {
  ::v-deep .list_account .el-dialog {
    width: 400px !important;
  }
}
@media (max-width: 499px) {
  ::v-deep .list_account .el-dialog {
    width: 300px !important;
  }
}
</style>
